(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("XX"));
	else if(typeof define === 'function' && define.amd)
		define(["XX"], factory);
	else if(typeof exports === 'object')
		exports["view"] = factory(require("XX"));
	else
		root["view"] = factory(root["XX"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 